var site = site || {};
site.bundleflow = site.bundleflow || {};

(function($, scope) {

  /*
   * JS to disable background scrolling when modal is enabled. This is specific
   * to ios safari which won't work with the html,body { overflow: hidden; }
   * trick. Basically it checks whether the modal is scrollable and then
   * prevents propogation if it can no longer scroll.
   */
  var _disable_ios_scrolling = function () {
    var _overlay = document.getElementById('colorbox');
    var _clientY = null; // remember Y position on touch start

    _overlay.addEventListener('touchstart', function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch
        _clientY = event.targetTouches[0].clientY;
      }
    }, false);

    _overlay.addEventListener('touchmove', function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch
        disableRubberBand(event);
      }
    }, false);

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - _clientY;

      if (_overlay.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        //element is at the top of its scroll
        event.preventDefault();
      }
    }

    function isOverlayTotallyScrolled() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
      return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
  }

  /*
   * The difference between BundleFlowDirector and BundleFlowState is that
   * BundleFlowState does not have a concept of an active step or things like
   * the overlay.
   */
  function BundleFlowDirector($flow, bundle_state) {
    this.bundle_state = bundle_state;
    this.$flow = $flow;

    this.active_step = null;

    this.set_initial_step();
    this.attach_handlers();
  }

  BundleFlowDirector.prototype.set_initial_step = function(skip_render) {
    var first_state = this.bundle_state.index_step(0);
    this.set_active_step(first_state.step_id, skip_render);
  };

  /*
   * SKU Reactions. Mutations that are triggered by sku select.
   */
  BundleFlowDirector.prototype.reset_sku_reactions = function($indicators) {
    $indicators.each(function(i, obj) {
      var $indicator = $(obj);
      $indicator.css('color', '');
      $indicator.css('background-image', '');
    });
  };

  BundleFlowDirector.prototype.apply_sku_reactions = function($indicators, skuBaseId) {
    $indicators.each(function(i, obj) {
      var $indicator = $(obj);
      var skuData = prodcat.data.getSku(skuBaseId);

      if (!skuData) {
        return;
      }

      if ($indicator.data('sku-reaction-color') && skuData['HEX_VALUE_STRING']) {
        $indicator.css('color', skuData['HEX_VALUE_STRING']);
      }

      // An empty IMAGE_ALT_S array is truthy, so test the element, not the array.
      var skuBackgroundImage = skuData['IMAGE_ALT_S'] && skuData['IMAGE_ALT_S'][0];

      if ($indicator.data('sku-reaction-background-image') && skuBackgroundImage) {
        $indicator.css('background-image', 'url(' + skuBackgroundImage + ')');
      }
    });
  };

  // main render loop for all steps
  BundleFlowDirector.prototype._render_sku_reactions = function() {
    var self = this;

    this.bundle_state.foreachStepState(function(step_id, step, state, options) {
      var $indicators = $('.js-bundle-step-indicator[data-step-id=' + step_id + ']',  self.$flow);
      if (!state.selectedSku) {
        self.reset_sku_reactions($indicators);
        return;
      }
      self.apply_sku_reactions($indicators, state.selectedSku);
    });
  };

  BundleFlowDirector.prototype.attach_handlers = function(step_id) {
    var self = this;

    // handle cta click
    $(self.bundle_state).on('next_cta_click', function(event, $button, step, state) {
      var step_order = step.step_order;
      var next_step = self.bundle_state.index_step(step_order + 1);
      var next_step_id = next_step.step_id;
      self.set_active_step(next_step_id);
    });

    // rerender to trigger things like sku reactions.
    $(self.bundle_state).on('bundle_sku_selected', function(e, step_id, skuBaseId) {
      self.render();
    });

    // edit links on review step
    $(self.$flow).on('click', '.js-bundle-edit-link, .js-bundle-flow-trigger', function(e) {
      e.preventDefault();
      var $link = $(this);
      var step_id = $link.data('step-id');
      self.set_active_step(step_id);
    });

    /*
     * We allow triggering bundle overlay via explicit class or use of a
     * special #bundle-overlay hash in links.
     */
    $(document).on('click', '.js-bundle-get-set-cta', function(e) {
      self.open_in_overlay();
    });

    // #bundle-overlay links
    $(document).on('click', 'a[href]', function(e) {
      var $link = $(this);
      var href = $link.attr('href');
      if (!href) {
        return;
      }

      var hash = $link[0].hash.substr(1);
      if (hash != 'bundle-overlay') {
        return;
      }
      e.preventDefault();
      self.open_in_overlay();
    });
  }

  BundleFlowDirector.prototype.set_active_step = function(step_id, skip_render) {
    skip_render = !!skip_render;
    this.active_step = step_id;
    if (!skip_render) {
      this.render();
    }
  };

  BundleFlowDirector.prototype.get_active_step = function() {
    var active_step = this.active_step;
    var step = this.bundle_state.get_step_from_id(active_step);
    return step;
  }

  /*
   * Reset state and re-render.
   */
  BundleFlowDirector.prototype.reset = function() {
    this.bundle_state.set_initial_state();
    this.set_initial_step(true);
    this.render();
  };

  /*
   * Overall render loop. This should be called.
   */
  BundleFlowDirector.prototype.render = function() {
    var active_step = this.active_step;
    this.bundle_state.setStepClass(active_step, 'active', true);
    // use attr() so css can see this
    this._render_review_step();
    this._render_sku_reactions();
    this.$flow.attr('data-step-id', active_step);
    this._render_swatchlists();
    this.bundle_state.updateView();

    var step = this.bundle_state.get_step_from_id(active_step);
    var $step = step.$dom;
    var $product = $('.js-product', $step);
    $product.trigger('bundleRevealProduct');
    $step.trigger('bundleRevealStep');
  };

  /*
   * Update swatchlists based on state. If No selectedSku, deselect the swatch.
   */
  BundleFlowDirector.prototype._render_swatchlists = function() {
    this.bundle_state.foreachStepState(function(step_id, step, state, options) {
      var $step = step.$dom;
      var $swatchList = $('.js-swatch-list', $step);
      if (!state.selectedSku) {
        $swatchList.triggerHandler('resetSwatchList');
      } else {
        $swatchList.triggerHandler('selectSwatch', [state.selectedSku]);
      }
    });
  };

  BundleFlowDirector.prototype._render_review_step = function() {
    var $render_target = $('.js-spp-bundle-layout__review__items');

    $render_target.empty();

    this.bundle_state.foreachStepState(function(step_id, step, state, options) {
      if (!step.product_id) {
        return;
      }
      if (!state.selectedSku) {
        return;
      }
      var product_id = step.product_id;
      var product = prodcat.data.getProduct(product_id);
      var sku = prodcat.data.getSku(state.selectedSku);
      var data = {
        'product': product,
        'selectedSku': sku,
        'step_id': step.step_id,
      };

      // pass on the bundle options.
      data['bundle_show_price'] = options.bundle_show_price;
      data['bundle_show_size'] = options.bundle_show_size;

      var content = site.template.get({
        name: 'bundle_review_item_v1',
        data: data
      })
      $render_target.append(content);
    });
  };

  /*
   * Check if the slide's cta button is in viewport. If not, then we:
   * 1. add a below-viewport class for triggering css
   * 2. Add the current value of the containers left.
   *
   * This is so the button can become sticky and line up with where the static
   * button would normally line up.
   */
  BundleFlowDirector.prototype._check_bottom_cta = function() {
    var step = this.get_active_step();
    var $step = step.$dom;
    var $bottom_cta = $('.js-bundle-step-cta', $step);
    var $button = $('.button', $bottom_cta);

    if ($button.length == 0) {
      return;
    }

    var rect = $bottom_cta[0].getBoundingClientRect();
    var button_height = $button.height();
    var cta_bottom = rect.bottom;

    if ($button.css('position') == 'fixed') {
      cta_bottom = cta_bottom + button_height;
    }

    if (cta_bottom > (window.innerHeight || document.documentElement.clientWidth)) {
      $bottom_cta.addClass('below-viewport');
      $button.css('left', rect.left);
    } else {
      $bottom_cta.removeClass('below-viewport');
      $button.css('left', '');
    }
  }

  /*
   * Remove event handlers and html classes
   */
  BundleFlowDirector.prototype.cleanup_overlay = function() {
    $('html').removeClass('no-scroll');
    $('html').removeClass('overlay-active');
    $('html').removeClass('fix-ios-bottom-drawer');
    $(window).off('.bundle_overlay');
    $(document).off('.bundle_overlay');
    $('#colorbox').off('.bundle_overlay');
  };

  /*
   * Attach event handlers and set html classes for overlay
   */
  BundleFlowDirector.prototype.attach_overlay_handlers = function() {
    var director = this;

    var _check_bottom_cta = function() {
      director._check_bottom_cta();
    }

    // callback for events that may require a resize
    var _resize = function() {
      if (!($.colorbox)) {
        return;
      }
      $.colorbox.resize();
      _check_bottom_cta();
      window.setTimeout(_check_bottom_cta, 300);
    };

    // when switching between steps. rerun reiszer and go to top
    $(window).on('bundleRevealStep.bundle_overlay', function() {
      _resize();
      $('#colorbox').scrollTop(0);
    });

    // add overlay specific classes.
    $('html').addClass('no-scroll');
    $('html').addClass('overlay-active');
    $('html').addClass('fix-ios-bottom-drawer'); // keep bottom drawer on

    $('#colorbox').on('scroll.bundle_overlay resize.bundle_overlay', _.debounce(_check_bottom_cta, 200));

    // On any resize/scroll, recalculate
    $(window).on('resize.bundle_overlay scroll.bundle_overlay', _.debounce(function() {
      _resize();
    }, 200));

    window.setTimeout(function() {
      _resize();
    }, 1000);
    _resize();

    // Reset modal on cart success. On failure, the overlay stays the same.
    $(document).on('addToCart.success.bundle_overlay', function(e) {
      director.reset();
    });

    $(document).on('addToCart.buttonStatus', function(e, $addBtn, status) {
      // use attr so css can catch it
      $addBtn.attr('data-button-status', status);
    });
  };

  /*
   * Open the bundle flow in an overlay. (colorbox);
   */
  BundleFlowDirector.prototype.open_in_overlay = function() {
    var director = this;
    var $flow = director.$flow;
    var options = {
      href: $flow,
      className: 'colorbox--bundle',
      escKey: false,
      inline: true, // retain state/events
      fixed: true,
    }

    options['onComplete'] = function() {
      director.attach_overlay_handlers();
    };

    options['onCleanup'] = function() {
      director.cleanup_overlay();
    }

    // sometimes a second cbox will popup and the previous cbox's cleanup
    // functions will not run correctly.
    $(document).on('cbox_cleanup.bundle_overlay', function(){
      director.cleanup_overlay();
    });

    generic.overlay.launch(options);
  };


  scope.BundleFlowDirector = BundleFlowDirector;

})(jQuery, site.bundleflow);
